export default __webpack_public_path__ + "static/media/buzzer.55d9a2d0.svg";